import { FC } from 'react';
import { InstantSearch } from 'react-instantsearch';
import { SearchBar } from './components/SearchBar';
import { AlgoliaUtil } from '../shared/utils';

const algoliaUtil = new AlgoliaUtil({
  appId: theme.algoliaId,
  apiKey: theme.algoliaApiKey,
  hitsPerPage: {
    products: 8,
    collections: 4,
    articles: 4,
  },
  indexNames: {
    product: theme.algoliaProductIndex,
    collection: theme.algoliaCollectionIndex,
    article: theme.algoliaPagesIndex,
  },
});

type AppProps = {
  initialSearchValue: string;
};

export const App: FC<AppProps> = () => {
  const instantSearchParams = algoliaUtil.getInstantSearchParams();
  const algoliaIndexes = algoliaUtil.getIndexes();

  return (
    <InstantSearch
      searchClient={instantSearchParams.searchClient}
      insights={{ insightsInitParams: { userToken: instantSearchParams.userToken } }}
    >
      <SearchBar
        indexes={{
          product: algoliaIndexes.product,
          collection: algoliaIndexes.collection!,
          article: algoliaIndexes.article!,
        }}
        algoliaUtil={algoliaUtil}
      />
    </InstantSearch>
  );
};
